<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header page-title="ORGÃOS PÚBLICOS"
          page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/office-building.png">
        </lib-page-header>
      </div>
      <div class="col-md-4">
        <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <table class="table table-eddy">
          <thead>
            <tr>
              <th scope="col" class="text-center">Código</th>
              <th scope="col">Nome</th>
              <th scope="col">CNPJ</th>
              <th scope="col">Espécie</th>
              <th scope="col" style="width: 90px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of lista">
              <th scope="row" class="text-center">{{item.codigo}}</th>
              <td>{{item.nome}}</td>
              <td>{{item.cnpj}}</td>
              <td *ngIf="item.especie === 'C'"><span class="badge badge-primary">CÂMARA MUNICIPAL</span></td>
              <td *ngIf="item.especie === 'P'"><span class="badge badge-secondary">PREFEITURA MUNICIPAL</span></td>
              <td *ngIf="item.especie === 'A'"><span class="badge badge-success">AUTARQUIA MUNICIPAL</span></td>
              <td *ngIf="item.especie === 'F'"><span class="badge badge-warning">FUNDAÇÃO MUNICIPAL</span></td>
              <td *ngIf="item.especie === 'I'"><span class="badge badge-info">INSTITUTO PREVIDÊNCIA</span></td>
              <td class="text-right">
                <button [routerLink]="['/orgaos', item.id, 'editar']" routerLinkActive="router-link-active"
                  *ngIf="podeIncluir()" class="btn btn-sm btn-outline-primary mr-2">
                  <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length > 0">
      <div class="col-12">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
  </div>
</div>
